export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    field: 'col-opt',
    align: 'center',
    fixed: 'right',
    width: 100,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'displayImage',
    width: 120,
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_displayName') || '面料名称',
    field: 'displayName',
    minWidth: 200,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_displaySpec') || '门幅/克重/颜色',
    field: 'displaySpec',
    minWidth: 200,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySpec' },
  },
  {
    title: that.$l('table_label_fabricContent') || '面料成分',
    field: 'fabricContent',
    minWidth: 200,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'fabricContent' },
  },
  {
    title: that.$l('table_label_fabricAgentName') || '业务开发',
    field: 'fabricAgentName',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_unitPrice') || '单价',
    field: 'unitPrice',
    minWidth: 100,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'unitPrice' },
  },
  {
    title: that.$l('table_label_displayScm') || '面料工厂',
    field: 'displayScm',
    minWidth: 200,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayScm' },
  },
]
